import NonRepeatableAddonList from '@/features/pos/components/ProductConfigurationModal/parts/AddonGroup/parts/NonRepeatableAddonList'
import RepeatableAddonList from '@/features/pos/components/ProductConfigurationModal/parts/AddonGroup/parts/RepeatableAddonList'
import OptionGroup from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup'
import { AddonGroup as AddonGroupType } from '@/features/pos/components/ProductConfigurationModal/types'
import { FC, memo } from 'react'

interface AddonGroupProps {
    addonGroup: AddonGroupType
}

const AddonGroup: FC<AddonGroupProps> = ({ addonGroup }) => {
    return (
        <OptionGroup
            name={addonGroup.name}
            minQuantity={addonGroup.minQuantity}
            maxQuantity={addonGroup.maxQuantity}
        >
            {addonGroup.withRepeatableItems && addonGroup.maxQuantity !== 1 ? (
                <RepeatableAddonList addonGroup={addonGroup} />
            ) : (
                <NonRepeatableAddonList addonGroup={addonGroup} />
            )}
        </OptionGroup>
    )
}

export default memo(AddonGroup)
